import React from 'react';

interface UsageIndicatorProps {
  current: number;
  limit: number;
  feature: string;
  className?: string;
}

const UsageIndicator: React.FC<UsageIndicatorProps> = ({
  current,
  limit,
  feature,
  className = ''
}) => {
  const isUnlimited = limit === Infinity;
  const percentage = isUnlimited ? 0 : Math.min(100, (current / limit) * 100);
  const progressColor = isUnlimited ? 'bg-green-500' : percentage >= 80 ? 'bg-red-500' : 'bg-blue-500';

  return (
    <div className={`mb-4 ${className}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{feature}</span>
        <span className="text-sm text-gray-600">
          {current} {isUnlimited ? '∞' : `of ${limit}`}
        </span>
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div 
          className={`h-full ${progressColor} transition-all duration-300`}
          style={{ width: isUnlimited ? '100%' : `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default UsageIndicator;